import { ComponentChild } from 'preact';

import styles from './InlineError.module.scss';

interface InlineErrorProps {
  children: ComponentChild;
  fieldId: string;
}

export function InlineError({ children, fieldId }: InlineErrorProps) {
  return (
    <div className={styles.InlineError} id={getId(fieldId)}>
      {children}
    </div>
  );
}

export function getId(fieldId: string) {
  return `${fieldId}Error`;
}
